var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:_vm.badgeClass},[(_vm.badgeClass === 'no-value')?_c('div',{staticClass:"number"},[_vm._v("\n    -\n  ")]):_c('div',{staticClass:"number"},[_vm._v("\n    "+_vm._s(_vm.npsValue)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }